import { useEffect, useMemo, useRef, useState } from "react";
import styled from "styled-components";
import Breadcrumbs from "../based/Breadcrumbs";
import Common from "../based/Common";
import { INITPAGING, NOTIFY } from "../based/Constants";
import { Notify } from "../based/Notify";
import EmailServices from "../based/services/EmailServices";
import PDF from "./assets/PDF.png";
import XML from "./assets/XML.png";

//tất cả/cần phát hành/cần điều chỉnh/quá hạn/đã phát hành
const TAB_SCREEN = [
    { label: "Tất cả", value: -1 },
    { label: "Đã đồng bộ hóa đơn", value: 2 },
    { label: "Thùng rác", value: 1 },
];

function InvoiceEmailOverview(props) {
    const [pagingModel, setPagingModel] = useState({ ...INITPAGING, inboundEmailStatus: -1 });
    const [listModel, setListModel] = useState([]);
    const observer = useRef(null);
    const [loading, setLoading] = useState(false);
    const [hasMore, setHasMore] = useState(true);

    const [selectModel, setSelectModel] = useState({});

    console.log("selectModel :>> ", selectModel);

    useEffect(() => {
        getDatas(pagingModel);
    }, []);

    const getDatas = async (page) => {
        setLoading(true);
        const [err, data] = await EmailServices.GetInboundEmailByPage(page);
        if (!err && data && data.listObjects && data.listObjects.length > 0) {
            if (page.pageNumber == 1) setListModel(data.listObjects);
            else setListModel([...listModel, ...data.listObjects]);
            setPagingModel(data.paging);
            setHasMore(true);
        } else {
            if (page.pageNumber == 1) setListModel([]);
            setHasMore(false);
            setPagingModel(page);
        }
        setLoading(false);
    };

    const setLastCollectionHandler = (element) => {
        if (loading || !hasMore) return;
        if (observer.current) observer.current.disconnect();
        observer.current = new IntersectionObserver((entries) => {
            if (entries[0].isIntersecting) {
                let updatePaging = { ...pagingModel };
                updatePaging.pageNumber += 1;
                getDatas(updatePaging);
            }
        });
        if (element) observer.current.observe(element);
    };

    const _renderTab = useMemo(() => (
        <ul className="nav nav-tabs tabs-bordered">
            {TAB_SCREEN.map((item, index) => {
                return (
                    <li key={index} className="nav-item">
                        <a
                            className={pagingModel.inboundEmailStatus == item.value ? "nav-link active" : "nav-link btn-light"}
                            onClick={() => {
                                getDatas({ ...pagingModel, pageNumber: 1, inboundEmailStatus: item.value });
                            }}
                        >
                            <span>{item.label}</span>
                        </a>
                    </li>
                );
            })}
        </ul>
    ));

    const handleArchive = async (id, status) => {
        const [err, data] = await EmailServices.UpdateArchiveInboundEmail(id, status);
        if (!err && data) {
            Notify(NOTIFY.SUCCESS, NOTIFY.SUCCESS, "Thành công");
            getDatas({ ...pagingModel });
        } else {
            Notify(NOTIFY.ERROR, NOTIFY.ERROR, "Thất bại");
        }
    };

    const getModel = async (id) => {
        const [err, data] = await EmailServices.GetInboundEmailById(id);
        if (!err && data) {
            setSelectModel(data);
        } else {
            setSelectModel({});
        }
    };

    return (
        <Wrapper>
            <Breadcrumbs currentPage="Quản lý hóa đơn" />
            {_renderTab}
            <div className="content_box">
                <div className="content_box-header">
                    <div className="content_box-header-left">
                        <span>Email</span>
                    </div>
                    <div className="content_box-header-right">
                        <span>Nội dung</span>
                    </div>
                </div>
                <div className="content_box-body">
                    <div className="content_box-body-left">
                        <div className="list_email">
                            {listModel && listModel.length > 0 ? (
                                listModel.map((x, index) => {
                                    return (
                                        <div
                                            className={`email_item ${selectModel && selectModel.id == x.id ? "active" : ""}`}
                                            key={index}
                                            ref={setLastCollectionHandler}
                                            onClick={(e) => {
                                                getModel(x.id);
                                            }}
                                        >
                                            <div className="email_item-badge">
                                                <span className="badge badge-custom">{/* Đã đồng bộ - Số hóa đơn: 223 <i className="fa fa-opencart"></i> */}</span>
                                            </div>
                                            <div className="email_item-content">
                                                <div className="email_item-content-subject">
                                                    <span>{x.subject}</span>
                                                    <a
                                                        onClick={(e) => {
                                                            e.preventDefault();
                                                            //nếu status đang là archive thì set lại normal
                                                            if (x.inboundEmailStatus != 1) {
                                                                handleArchive(x.id, 1);
                                                            } else {
                                                                handleArchive(x.id, 0);
                                                            }
                                                        }}
                                                    >
                                                        <i className="fa fa-trash"></i>
                                                    </a>
                                                </div>
                                                <div className="email_item-content-from">
                                                    <span>{`${x.from}`}</span>
                                                </div>
                                                <div className="email_item-content-local-datetime">{x.localDateTime && <span>{Common.formatDate(new Date(x.localDateTime))}</span>}</div>
                                                <div className="email_item-content-list-file">
                                                    {x.listAttachment &&
                                                        x.listAttachment.map((ele, i) => {
                                                            let fileName = Common.getFileNameWithoutExtension(ele);
                                                            let extension = Common.getFileExtension(ele);
                                                            if (fileName.length > 10) {
                                                                fileName = fileName.substring(0, 9) + "....";
                                                            }

                                                            let imgFile = extension && extension.toLowerCase() == ".pdf" ? PDF : XML;
                                                            return (
                                                                <div
                                                                    className="file_item"
                                                                    key={i}
                                                                    onClick={(e) => {
                                                                        e.preventDefault();
                                                                        window.open(ele, "_blank");
                                                                    }}
                                                                >
                                                                    <div className="icon">
                                                                        <img src={imgFile} alt="" />
                                                                    </div>
                                                                    <div className="file_name">
                                                                        <span>
                                                                            {fileName}
                                                                            {extension}
                                                                        </span>
                                                                    </div>
                                                                </div>
                                                            );
                                                        })}
                                                </div>
                                            </div>
                                        </div>
                                    );
                                })
                            ) : (
                                <div>Không có dữ liệu</div>
                            )}
                        </div>
                    </div>

                    <div className="content_box-body-right">
                        {selectModel && (
                            <>
                                <div className="content_box-body-right-subject">
                                    <span>{selectModel.subject}</span>
                                </div>
                                <div className="content_box-body-right-from">
                                    <span>{selectModel.from}</span>
                                </div>
                                <div className="content_box-body-right-date">{selectModel.localDateTime && <span>{Common.formatDate(new Date(selectModel.localDateTime))}</span>}</div>
                                <div className="content_box-body-right-text-body">
                                    <p>{selectModel.textBody}</p>
                                </div>
                                <div className="content_box-body-right-list-file">
                                    <label htmlFor="">File đính kèm</label>
                                    <div className="email_item-content-list-file">
                                        {selectModel.listAttachment &&
                                            selectModel.listAttachment.map((ele, i) => {
                                                let fileName = Common.getFileNameWithoutExtension(ele);
                                                let extension = Common.getFileExtension(ele);
                                                if (fileName.length > 10) {
                                                    fileName = fileName.substring(0, 9) + "....";
                                                }
                                                let imgFile = extension && extension.toLowerCase() == ".pdf" ? PDF : XML;
                                                return (
                                                    <div
                                                        className="file_item"
                                                        key={i}
                                                        onClick={(e) => {
                                                            e.preventDefault();
                                                            window.open(ele, "_blank");
                                                        }}
                                                    >
                                                        <div className="icon">
                                                            <img src={imgFile} alt="" />
                                                        </div>
                                                        <div className="file_name">
                                                            <span>
                                                                {fileName}
                                                                {extension}
                                                            </span>
                                                        </div>
                                                    </div>
                                                );
                                            })}
                                    </div>
                                </div>
                            </>
                        )}
                    </div>
                </div>
            </div>
        </Wrapper>
    );
}

export default InvoiceEmailOverview;

const Wrapper = styled.div`
    .content_box-header {
        display: flex;
        align-items: center;
        border: 1px solid #ededed;
        background: #e4e4e4;
    }

    .content_box {
        margin-top: 10px;
    }

    .content_box-header-left {
        width: 30%;
        padding: 6px 0 6px 12px;
    }

    .content_box-header-left span {
        color: #444;
        font-family: Roboto;
        font-size: 14px;
        font-style: normal;
        font-weight: 700;
        line-height: normal;
    }

    .content_box-header-right span {
        color: #444;
        font-family: Roboto;
        font-size: 14px;
        font-style: normal;
        font-weight: 700;
        line-height: normal;
    }

    .content_box-header-right {
        flex: 1;
        padding: 6px 0 6px 12px;
    }

    .content_box-body-left {
        width: 30%;
    }

    .content_box-body {
        display: flex;
    }

    .list_email {
        background: #fff;
    }

    .email_item {
        padding: 18px 20px;
    }

    .email_item.active {
        background: #c2e7df;
    }

    .email_item-content-subject span {
        overflow: hidden;
        color: #444;
        text-overflow: ellipsis;
        font-family: Roboto;
        font-size: 14px;
        font-style: normal;
        font-weight: 700;
        line-height: normal;

        display: -webkit-box;
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;
        overflow: hidden;
        text-overflow: ellipsis;
        word-break: break-word;
    }

    .email_item-content-subject a {
        margin-left: 6px;
    }

    .email_item-content-subject {
        display: flex;
        align-items: center;
    }

    .email_item-content-from span {
        color: #444;
        font-family: Roboto;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
    }

    .email_item-content-from {
        margin: 4px 0;
    }

    .email_item-content-local-datetime span {
        color: #444;
        font-family: Roboto;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
    }

    .email_item-content-local-datetime {
        margin: 4px 0;
    }

    .email_item-content-list-file {
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        gap: 6px;
    }

    .file_item {
        border-radius: 50px;
        border: 1px solid #ededed;
        background: #fff;
        display: flex;
        align-items: center;
        padding: 3px 8px;
        cursor: pointer;
    }

    .file_item .file_name {
        color: #444;
        font-family: Roboto;
        font-size: 12px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        margin-left: 6px;
    }

    .content_box-body-right {
        flex: 1;
        border: 1px solid #ededed;
        background: #fff;
        padding: 24px;
    }

    .content_box-body-right-subject span {
        overflow: hidden;
        color: #444;
        text-overflow: ellipsis;
        font-family: Roboto;
        font-size: 18px;
        font-style: normal;
        font-weight: 700;
        line-height: normal;
    }

    .content_box-body-right-from span {
        color: #444;
        font-family: Roboto;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
    }

    .content_box-body-right-from {
        margin: 6px 0;
    }

    .content_box-body-right-date span {
        color: #444;
        font-family: Roboto;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
    }

    .content_box-body-right-date {
        margin: 8px 0;
    }

    .content_box-body-right-text-body p {
        color: #444;
        font-family: Roboto;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
    }
`;
